export const DEFAULT_LOCATION = 'Origin\\';
